import { createApp } from 'vue'

// Import CSS in correct order: variables → base → specific → responsive
import './assets/styles/variables.css'      // CSS custom properties (must load first)
import './assets/styles/main.css'           // Base styles
import './assets/styles/utilities.css'      // Utility classes for common patterns
import './assets/styles/cards.css'          // Card-specific styles
import './assets/styles/animations.css'     // Animation definitions
import './assets/styles/messages.css'       // Toast/message styles
import './assets/styles/waiting-room.css'   // Lobby styles
import './assets/styles/responsive.css'     // Media queries (load last)

import App from './App.vue'

// Expose Logger globally for browser console debugging
import { Logger, LogLevel, LogCategory } from './utils/Logger.class'
declare global {
  interface Window {
    Logger: typeof Logger
    LogLevel: typeof LogLevel
    LogCategory: typeof LogCategory
  }
}
window.Logger = Logger
window.LogLevel = LogLevel
window.LogCategory = LogCategory

createApp(App).mount('#app')
